// extracted by mini-css-extract-plugin
module.exports = {"reference":"FootnoteNodeView_reference__MyKoC","selected":"FootnoteNodeView_selected__k0toQ"};